module.exports = __webpack_public_path__ + "img/image 256.b286a540.png";